export const minedexCommodoties = [
  { commodityId: "ALUMINA", iconClassName: "fa fa-solid fa-square", color: "#c64600" },
  { commodityId: "IRON", iconClassName: "fa fa-solid fa-square", color: "#1a5fb4" },
  { commodityId: "PRECIOUS METAL", iconClassName: "fa fa-solid fa-square", color: "#FFD43B" },
  { commodityId: "SPECIALITY METAL", iconClassName: "fa fa-solid fa-square", color: "#57e389" },
  { commodityId: "STEEL ALLOY METAL", iconClassName: "fa fa-solid fa-square", color: "#ff7a00" },
  { commodityId: "CONSTRUCTION MATERIAL", iconClassName: "fa fa-solid fa-play fa-rotate-270", color: "#62a0ea" },
  { commodityId: "BASE METAL", iconClassName: "fa fa-solid fa-play fa-rotate-270", color: "#ed333b" },
  { commodityId: "ENERGY", iconClassName: "fa fa-solid fa-play fa-rotate-270", color: "#000000" },
  { commodityId: "INDUSTRIAL MINERAL", iconClassName: "fa fa-solid fa-circle", color: "#26a269" },
  { commodityId: "PRECIOUS MINERAL", iconClassName: "fa fa-solid fa-star", color: "#9a9996" },
  { commodityId: "OTHER (MINEDEX NON-MINERALS)", iconClassName: "fa fa-solid fa-xmark", color: "#f770d3" }
];


export const minedexTargetComodotiy = 
["ANTIMONY" 
,"IRON ORE"
,"ALUNITE"
,"COAL"
,"FLUORITE"
,"DIAMOND"
,"TIN - TANTALUM - LITHIUM"
,"SILVER"
,"TALC"
,"BISMUTH"
,"TUNGSTEN - MOLYBDENUM"
,"OTHER"
,"INDUSTRIAL PEGMATITE MINERALS"
,"ANDALUSITE - KYANITE - SILLIMANITE - CORUNDUM"
,"GRAPHITE"
,"DOLOMITE"
,"CLAYS"
,"GEM & SEMI-PRECIOUS STONES"
,"URANIUM"
,"NICKEL"
,"ARSENIC"
,"PEAT"
,"GYPSUM"
,"PIGMENTS"
,"BARITE"
,"PHOSPHATE"
,"UNASSIGNED"
,"COPPER - LEAD - ZINC"
,"ASBESTOS"
,"GREENSAND - GLAUCONITE"
,"POTASH"
,"HEAVY MINERAL SANDS"
,"LIMESTONE - LIMESAND"
,"MANGANESE ORE"
,"MAGNESITE"
,"SALT"
,"PYRITE - SULFUR"
,"GOLD"
,"DIMENSION STONE"
,"CHROMITE - PLATINOIDS"
,"CONSTRUCTION MATERIALS"
,"PETROLEUM"
,"VANADIUM - TITANIUM"
,"RARE EARTHS"
,"DIATOMITE - SPONGOLITE"
,"VERMICULITE"
,"BAUXITE - ALUMINA"
,"CHEMICALS"
,"SILICA - SILICA SAND"];


export const minedexSiteType = [
"Prospect"
,"Other"
,"Unknown"
,"Deposit"
,"Infrastructure"
,"Geological Observation"
,"Mine"
,"Occurrence"
,"Target"
]
